module.exports = __webpack_public_path__ + "resources/img/img_ssl_ceritificate2.ef71ac46996d29f8047a67429d11014b.png";